import { useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';
import s from './styles.module.scss';

export const SmartBanner = () => {
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		const closed = localStorage.getItem('smartbanner-closed');

		if (!Capacitor.isNativePlatform() && !closed) {
			setVisible(true);
		}
	}, []);

	const onClose = () => {
		localStorage.setItem('smartbanner-closed', '1');
		setVisible(false);
	};

	if (!visible) return null;

	const ua = navigator.userAgent;

	const isAndroid = /Android/i.test(ua);
	const isIOS =
		/iPhone|iPad|iPod/i.test(ua) || (navigator.platform === 'MacIntel' && (navigator as any).maxTouchPoints > 1);

	const isMobile = isAndroid || isIOS;

	const googlePlayLink = 'https://bit.ly/3GoqWY2';
	const appStoreLink = 'https://apple.co/3RBqRCO';

	const mobileLink = isAndroid ? googlePlayLink : appStoreLink;

	return (
		<div className={s.banner}>
			<img src="/favicon.webp" className={s.icon} alt="Логотип HOST" />
			<div className={s.info}>
				<div className={s.title}>HOSTPAY</div>
				<div className={s.desc}>В застосунку зручніше</div>
			</div>

			{isMobile ? (
				<a href={mobileLink} className={s.button}>
					Встановити
				</a>
			) : (
				<div className={s.actions}>
					<a href={googlePlayLink} className={s.button}>
						Google Play
					</a>
					<a href={appStoreLink} className={s.button}>
						App Store
					</a>
				</div>
			)}

			<button className={s.close} onClick={onClose}>
				×
			</button>
		</div>
	);
};
